
export const Home = (props: {}) => {
  return <div>
    <h1>Hi there</h1>
  </div>
}
